import { useTranslation } from "react-i18next";

const LOCALES = [
  { code: "en", label: "English" },
  { code: "pt-BR", label: "Português (BR)" },
] as const;

export function LanguageSelector() {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith("pt") ? "pt-BR" : "en";

  return (
    <select
      value={current}
      onChange={(e) => i18n.changeLanguage(e.target.value)}
      aria-label="Language"
      className="text-xs font-medium px-2 py-1 rounded transition-colors"
      style={{
        color: "var(--color-muted-foreground)",
        border: "1px solid var(--color-border)",
        background: "var(--color-card)",
        cursor: "pointer",
        letterSpacing: "0.02em",
        outline: "none",
      }}
    >
      {LOCALES.map(({ code, label }) => (
        <option key={code} value={code}>{label}</option>
      ))}
    </select>
  );
}

export { LOCALES };
